/**
 * Google Sign-In client ID. Public by design — it ships in the bundle and the
 * API verifies every ID token against the same value server side.
 */
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "481338672906-flcd6hp10b7svfp0k5q8t289l5bmv40q.apps.googleusercontent.com";
